import { finish, error } from 'src/modules/reports/actions/query';
import api from 'src/api';
import { apiCommon } from 'src/api/ApiCommon';

export function request(dispatch, { id, reportType, accountId }) {
    if (reportType === 'isonis') {
        return apiCommon.getIsonis.run({}).then(
            (data) => dispatch(finish(id, accountId, data)),
            ({errors}) => dispatch(error(id, errors))
        );
    }

    let url;

    if (reportType === 'statements') {
        url = `/document-reports/${reportType}/${accountId}`;
    } else {
        url = `/document-reports/${reportType}`;
    }

    api.get(url, void 0, { cache: true }).then(
        (data) => dispatch(finish(id, accountId, data)),
        ({ errors }) => dispatch(error(id, errors))
    );
}
